import { Link, useLocation } from "react-router-dom";
import type { SecondaryNavItem } from "./nav/secondarySidebarNav";

function pathMatches(pathname: string, to: string): boolean {
  if (to === "/bilan") return pathname === "/bilan";
  return pathname === to || pathname.startsWith(`${to}/`);
}

export function SecondarySubmenuLinks({
  items,
  onNavigate,
}: {
  items: SecondaryNavItem[];
  onNavigate?: () => void;
}) {
  const location = useLocation();

  return (
    <nav className="flex flex-col">
      {items.map((item) => {
        const isActive = pathMatches(location.pathname, item.path);
        return (
          <Link
            key={item.path + item.label}
            to={item.path}
            state={item.navState}
            onClick={() => onNavigate?.()}
            className={[
              "group mb-2 block rounded-lg border-l-[3px] p-3 transition-colors duration-150",
              isActive
                ? "border-teal-500 bg-teal-50"
                : "border-transparent bg-orange-50/35 hover:bg-orange-100",
            ].join(" ")}
          >
            <div
              className={
                isActive
                  ? "text-sm font-medium text-teal-900"
                  : "text-sm font-medium text-slate-900 transition-colors duration-150 group-hover:text-slate-950"
              }
            >
              {item.label}
            </div>
            <div
              className={
                isActive
                  ? "text-xs text-orange-800"
                  : "text-xs text-orange-800 transition-colors duration-150"
              }
            >
              {item.description}
            </div>
          </Link>
        );
      })}
    </nav>
  );
}
